export const MAP_SHIFT_CONSTANT: number = 456